import { TestList } from "../../../components/tests/TestList.js";
import { useSubjectContext } from "../useSubjectContext.js";
import { EmptyState, useT } from "@mmm/ui";
// Tests are AI-generated only — there is no manual test creation.
export function AITestListScreen() {
  const { subject } = useSubjectContext();
  const t = useT();

  return (
    <div>
      {subject.aiTests.length === 0 ? (
        <EmptyState title={t("tests.noTestsTitle")} message={t("tests.noTestsMessage")} />
      ) : (
        <TestList tests={subject.aiTests} subjectId={subject.id} />
      )}
    </div>
  );
}
